import '../modules/uPopup';
import {cookie} from '../modules/cookie';


var raskhlop = function(el){
    var param = JSON.parse(el.getAttribute('data-param')),
        autostart = param.autostart === false ? false : true,
        install = function(){
            var myPopup,
                closeBox,
                timeStart,
                timeDur = 2000,
                onopen = function(wrapper){
                    window.scrollBy(0,0);
                    timeStart = new Date().getTime();
                    countdown();
                },
                oncloseBefore = function(){
                    if(closeBox.innerHTML !== 'Закрыть') return false;
                    return true;
                },
                onclose = function (){
                    try{document.body.removeChild(el)} catch(e){};
                },
                countdown = function(){
                    var skipTime = Math.ceil((timeDur + timeStart - new Date().getTime())/1000);

                    /* При открывании расхлопа через кнопку счетчик не нужен */
                    if(skipTime > 0 && autostart){
                        closeBox.innerHTML = 'Закрыть через ' + skipTime;
                        requestAnimationFrame(countdown);
                    }
                    else closeBox.innerHTML = 'Закрыть';
                },
                addPixel = function(){
                    for(var i= 0,j=param.px.length; i<j; i++){
                        var img = document.createElement('IMG'),
                            src = param.px[i];

                        img.setAttribute('class', 'px');
                        img.setAttribute('src', src + '&rnd=' + new Date().getTime());
                        document.body.appendChild(img);
                    }
                },
                setCookie = function(expires){
                    var options = {},
                        domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
                        i = 0,
                        l = domains.length;

                    options.expires = expires;
                    options.path = '/';

                    for(i; i<l; i++){
                        options.domain = domains[i];
                        cookie.setCookie('branding_raskhlop', '1', options);
                    }
                };

            //
            addPixel();
            setCookie(3600*12/2);
            myPopup = uPopup({
                addClass: 'popup-illumination',
                content: el,
                //onopen: onopen,
                //oncloseBefore: oncloseBefore,
                onclose: onclose
            });
            closeBox = myPopup.table.querySelector('.popup_close');
            //closeBox.innerHTML = '';
            closeBox.innerHTML = 'Закрыть';
            closeBox.className = closeBox.className + ' js-active';
        },
        start = function(){
            if (document.readyState === "complete") {
                install();
            } else {
                window.addEventListener('load', install);
            }
        },
        returnObj = {
            start: start
        };



    //
    param.px = typeof param.px === 'string' ? [param.px] : param.px;

    if(autostart) {
        if (!navigator.cookieEnabled) return false;
        if (window.location.hostname.indexOf('kinoafishaspb.ru') !== -1) return false; /* на деве не показываем расхлоп */
        if(!cookie.getCookie('branding_raskhlop') || window.location.pathname.indexOf('/branding/') !== -1) start();
    } else {
        return returnObj;
    }
}

export {raskhlop};


